import {get, post} from '../config/http.js'


export default {
	login :(params) => {
		return post('/admin/login', params)
	},
	logout :(params) => {
		return get('/index.php?r=mobileapp/profile/closeLogin')
	},
}



// WEBPACK FOOTER //
// ./src/api/login.js